import { render, staticRenderFns } from "./CrosswordEdit.vue?vue&type=template&id=452d695e"
import script from "./CrosswordEdit.vue?vue&type=script&lang=js"
export * from "./CrosswordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports